module.exports = function() {
  return new Worker(__webpack_public_path__ + "7624f23d7346da2d3b86.worker.js");
};